import React from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { trocaEmpresa } from '../../crud/embarcador/filiais.crud';
import * as utils from "../../../_metronic/utils/utils";
import * as auth from "../../store/ducks/auth.duck";
import { persistor } from "../../store/store";
import { formatCNPJ, hasPermission, permissoesDaPersona } from "../../utils/Utils";
import { connect } from "react-redux";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";
import Swal from "sweetalert2";

class UserProfile extends React.Component {
	state = {
		empresasAbertas: false,
	}

	changeEmpresa(empresa) {
		if (empresa.empresa_id === this.props.user?.usu_id_empresa) return;

		Swal.fire({
			title: 'Atenção!',
			text: `Deseja alterar para a empresa: ${empresa.nome} ?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#2A449A',
			cancelButtonColor: '#D92D20',
			cancelButtonText: "Não",
			confirmButtonText: 'Sim'
		}).then((result) => {
			if (!result.isConfirmed) return;

			let form = new FormData();
			form.append('id_muda_empresa', empresa.empresa_id);

			trocaEmpresa(form).then(({ data }) => {
				utils.setStorage('authToken', data.data.token, null);
				this.props.atualizarToken(data.data.token);
				persistor.flush().then(() => window.location.reload(true));
			}).catch((err) => {
				return Swal.fire('Ops!', err.response?.data?.message ?? err.response?.data?.error ?? 'Não foi possível trocar de empresa.', 'error');
			});
		});
	}

	render() {
		const { user, showHi, showAvatar, permissions } = this.props;
		const chaves = permissoesDaPersona(user?.token_type);
		const pode = (chave) => hasPermission(permissions, chave);
		const empresasAcessiveis = user?.empresas_acessiveis ?? [];
		return (
			<Dropdown className="kt-header__topbar-item kt-header__topbar-item--user" drop="down" alignRight>
				<Dropdown.Toggle as={HeaderDropdownToggle} id="dropdown-toggle-user-profile">
					<div className="kt-header__topbar-user">

						{showHi && (
							<div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', flexDirection: 'column' }}>
								<span className="kt-header__topbar-username kt-hidden-mobile" style={{ alignSelf: 'flex-end' }}>{user?.usu_nome}</span>
								<span className="kt-header__topbar-username kt-hidden-mobile" style={{ fontSize: 12, color: 'gray', alignSelf: 'flex-end' }}>
									{user?.empresa?.emp_nome_fantasia}
								</span>

							</div>
						)}

						{/*showHi && (<span className="kt-header__topbar-username kt-hidden-mobile">{`${user?.usu_nome} #${this.state?.empresa?.usuario?.usu_id_empresa == undefined ? '' : this.state?.empresa?.usuario?.usu_id_empresa}`}</span>)*/}

						{showAvatar &&
							<div style={{
								width: '34px', height: '34px', backgroundImage: `url(${user?.empresa?.logo ? user?.empresa?.logo?.url : '/images/no-profile.png'})`,
								backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: '50% 50%', borderRadius: '50%'
							}} />
						}
					</div>
				</Dropdown.Toggle>

				<Dropdown.Menu className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
					<div className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
						style={{ backgroundColor: 'var(--color-secondary)' }}>

						{showAvatar &&
							<div className="kt-user-card__avatar">
								<span className="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success">
									<img alt="" src={user?.empresa?.logo ? user?.empresa?.logo?.url : '/images/no-profile.png'} />
								</span>
							</div>
						}

						<div className="kt-user-card__name">{user?.usu_nome}</div>
					</div>


					<div className="kt-notification menu-usuario">
						{pode(chaves.PERFIL_VIEW) && (
							<Link to={`/${user?.token_type === 'transportadora' ? 'transportador' : 'embarcador'}/meu-perfil`} className="kt-notification__item">
								<div className="kt-notification__item-icon">
									<i className="fas fa-id-card" />
								</div>
								<div className="kt-notification__item-details">
									<div className="kt-notification__item-title kt-font-bold">Meu Perfil</div>
									<div className="kt-notification__item-time">Veja e atualize seus dados pessoais.</div>
								</div>
							</Link>
						)}

						{pode(chaves.EMPRESA_VIEW) && (
							<Link to={`/${user?.token_type === 'transportadora' ? 'transportador' : 'embarcador'}/minha-empresa`} className="kt-notification__item">
								<div className="kt-notification__item-icon">
									<i className="flaticon2-user" />
								</div>
								<div className="kt-notification__item-details">
									<div className="kt-notification__item-title kt-font-bold">Minha empresa</div>
									<div className="kt-notification__item-time">Atualize as informações da empresa.</div>
								</div>
							</Link>
						)}

						{pode([chaves.USUARIO_LIST, chaves.EMPRESA_GROUP_LIST]) && (
							<Link to={`/${user?.token_type === 'transportadora' ? 'transportador' : 'embarcador'}/colaborador`} className="kt-notification__item">
								<div className="kt-notification__item-icon">
									<i className="fas fa-users" />
								</div>
								<div className="kt-notification__item-details">
									<div className="kt-notification__item-title kt-font-bold">Meus colaboradores</div>
									<div className="kt-notification__item-time">Colaboradores e grupos de acesso da empresa.</div>
								</div>
							</Link>
						)}

						{user?.empresa?.emp_flag_embarcador_armazem === 1 && pode(chaves.LOCAL_LIST) && (
							<Link to={`/${user?.token_type === 'transportadora' ? 'transportador' : 'embarcador'}/locais`} className="kt-notification__item">
								<div className="kt-notification__item-icon">
									<i className="fas fa-industry" />
								</div>
								<div className="kt-notification__item-details">
									<div className="kt-notification__item-title kt-font-bold">Meus Locais</div>
									<div className="kt-notification__item-time">Informações sobre seus Locais.</div>
								</div>
							</Link>
						)}


						{empresasAcessiveis.length > 1 && (
							<>
								<div style={{ cursor: 'pointer' }} onClick={() => this.setState({ empresasAbertas: !this.state.empresasAbertas })} className="kt-notification__item">
									<div className="kt-notification__item-icon">
										<i className="fas fa-exchange-alt" />
									</div>
									<div className="kt-notification__item-details">
										<div className="kt-notification__item-title kt-font-bold">Trocar de empresa</div>
										<div className="kt-notification__item-time">{`${empresasAcessiveis.length} empresas disponíveis`}</div>
									</div>
									<i className={`fas fa-chevron-${this.state.empresasAbertas ? 'up' : 'down'}`} style={{ color: 'var(--color-accent)', fontSize: 12 }} />
								</div>

								{this.state.empresasAbertas && (
									<div style={{ maxHeight: 260, overflowY: 'auto', backgroundColor: '#f7f8fa', borderTop: '1px solid #ebedf2', borderBottom: '1px solid #ebedf2' }}>
										{empresasAcessiveis.map((empresa) => {
											const empresaAtual = user?.usu_id_empresa === empresa.empresa_id;

											return (
												<div
													key={empresa.empresa_id}
													onClick={() => this.changeEmpresa(empresa)}
													className="kt-notification__item"
													style={{
														position: 'relative',
														cursor: empresaAtual ? 'default' : 'pointer',
														paddingLeft: 32,
														borderLeft: `3px solid ${empresaAtual ? 'var(--color-accent)' : 'transparent'}`,
														backgroundColor: empresaAtual ? 'var(--color-accent-bg)' : 'transparent',
													}}
												>
													<div className="kt-notification__item-icon">
														<i className="fas fa-industry" style={{ color: empresaAtual ? 'var(--color-accent)' : undefined }} />
													</div>
													<div className="kt-notification__item-details" style={{ flex: 1 }}>
														<div className="kt-notification__item-title" style={{ fontWeight: empresaAtual ? 700 : 500 }}>
															{empresa.nome}
														</div>
														<div className="kt-notification__item-time">{formatCNPJ(empresa.cnpj ?? '')}</div>
													</div>
													{empresaAtual && <i className="fas fa-asterisk" style={{ position: 'absolute', top: 6, right: 10, fontSize: 9, color: 'red' }} />}
													{empresa.tipo === 'matriz' && (
														<span className="kt-badge kt-badge--inline kt-badge--pill" style={{ marginLeft: 'auto', backgroundColor: 'var(--color-accent-bg)', color: 'var(--color-accent-active)', border: '1px solid var(--color-gold-300)' }}>Matriz</span>
													)}
												</div>
											);
										})}
									</div>
								)}
							</>
						)}

						<div className="kt-notification__custom flex-column align-items-start">
							<Link to="/logout" className="btn btn-primary btn-bold">Sair</Link>
						</div>
					</div>
				</Dropdown.Menu>
			</Dropdown>
		);
	}
}

const mapStateToProps = ({ auth: { user, permissions } }) => ({ user, permissions });

export default connect(mapStateToProps, auth.actions)(UserProfile);
